import React, { Component, Suspense } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { ToastProvider } from './services1/toastService'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './scss/style.scss'
import PrivateRoute from './components/PrivateRoute'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Lazy loaded Containers/Pages
// const LoungeUserDash = React.lazy(() => import("./features/Lounge/UserDashBoard"));
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const GuestLogin = React.lazy(() => import('./views/pages/GuestLogin/guestLogin'))
const GuestDashboard = React.lazy(() => import('./views/pages/GuestLogin/guestDashboard'))
const ChangePassword = React.lazy(() => import('./views/pages/login/changePassword'))
const ForgetPassword = React.lazy(() => import('./views/pages/login/forgetPassword'))
const ResetPassword = React.lazy(() => import('./views/pages/login/resetPassword'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/login/Page404'))
const SuccessHandle = React.lazy(() => import('./views/pages/login/SSOSuccessHandle'))
const SSOError = React.lazy(() => import('./views/pages/login/SSOError'))
const BRlogin = React.lazy(() => import('./views/pages/BRlogin'))

class App extends Component {
  render() {
    return (
      <Router>
        {/* Global Components */}

        <Suspense fallback={loading}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/guestLogin" element={<GuestLogin />} />
            <Route path="/forgetPassword" element={<ForgetPassword />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/guestDashboard" element={<GuestDashboard />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/sso/login/success" element={<SuccessHandle />} />
            <Route path="/sso/login/error" element={<SSOError />} />
            <Route path="/brlogin" element={<BRlogin />} />
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <DefaultLayout />
                </PrivateRoute>
              }
            />
            {/* <Route path="/*" element={<DefaultLayout />} /> */}
            {/* <Route path="/loungUserDash" element={<LoungeUserDash />} /> */}
          </Routes>
        </Suspense>

        <ToastProvider />
      </Router>
    )
  }
}

export default App
